import { render, staticRenderFns } from "./CraftingPanel.vue?vue&type=template&id=228f9104&scoped=true"
import script from "./CraftingPanel.vue?vue&type=script&lang=js"
export * from "./CraftingPanel.vue?vue&type=script&lang=js"
import style0 from "./CraftingPanel.vue?vue&type=style&index=0&id=228f9104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f9104",
  null
  
)

export default component.exports